import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { IFechRequest } from "interfaces/fetch-duck";
import { requestErrorHandler } from "utils";
import { FetchOrderFOBActions } from "store/ducks/ordersFob";

export function* fetchOrderFOBRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(api.get, `/orders-fob/${id}`);

    yield put(FetchOrderFOBActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchOrderFOBActions.failure(errorMessage));
  }
}
